export class VknTckn {
    public VKNTCKN: string
    public CONFIRMATION_CODE: string
    public EMAIL: string
}
